import { render } from "./ProjectCities.vue?vue&type=template&id=906dcc6e&scoped=true"
import script from "./ProjectCities.vue?vue&type=script&lang=js"
export * from "./ProjectCities.vue?vue&type=script&lang=js"

import "./ProjectCities.vue?vue&type=style&index=0&id=906dcc6e&scoped=true&lang=css"

import exportComponent from "/Users/mustafatofur/Desktop/Work/ProjectCountMap/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-906dcc6e"]])

export default __exports__